import React from "react"

import Layout from "../components/layout/layout"
import ContainerImplementation from "../components/implementation/container-implementation"
import HeadTag from "../components/component/headTag"

const Implementation = props => {
  const currentLocation = props.location.pathname

  return (
    <Layout currentLocation={currentLocation}>
      <ContainerImplementation />
    </Layout>
  )
}

export default Implementation

export const Head = () => <HeadTag title="Implementacion" />
